export const Footer = () => (
  <footer className="relative z-10 border-t border-[#DDD7CF] mt-24 bg-[#EFEBE6]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
      <div className="flex items-center gap-3 mb-4">
        <img src="/eb-logo.png" alt="Eternal Biolabs" className="h-8 w-auto" />
        <span className="flex flex-col leading-none">
          <span className="font-display text-sm tracking-[0.25em] text-[#1A1A1A]">ETERNAL</span>
          <span className="text-[9px] tracking-[0.5em] text-[#8C7B6B] font-semibold mt-1">BIOLABS</span>
        </span>
      </div>
      <p className="text-xs text-[#6E675F] max-w-2xl leading-relaxed" data-testid="footer-disclaimer">
        All products sold are intended strictly for laboratory research purposes only and are not
        for human or veterinary use. By purchasing, you confirm you are a qualified researcher.
      </p>
      <p className="text-xs text-[#6E675F] mt-6">© {new Date().getFullYear()} Eternal Biolabs. Payment via Interac e-Transfer.</p>
    </div>
  </footer>
);
